import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
const ScrollToTop = () => {
    const { pathname } = useLocation();
    const navigationType = useNavigationType();
    useEffect(() => {
        if (navigationType === 'PUSH') {
            const timeout = setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                // Fallback for mobile if smooth scroll doesn't work
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 500);
            }, 100); // wait for DOM/rendering
            return () => clearTimeout(timeout);
        }
    }, [pathname, navigationType]);
    useEffect(() => {
        const handleClick = (e) => {
            const target = e.target.closest('a');
            if (target && target.href === window.location.href) {
                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setTimeout(() => {
                        window.scrollTo(0, 0); // fallback
                    }, 500);
                }, 0);
            }
        };
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);
    return null;
};
export default ScrollToTop;
